import {
  formatVideoToolboxClipReadStatusAriaLabel,
  type VideoToolboxClipReadStatus,
} from '../../VideoToolbox/videoToolboxClipReadStatusLib';
import type { FocusedMediaStripVideoEntry } from '../focusedMediaStripLib';
import { getTruncatedChipLabel } from './focusedStripPhotoTileLib';
import {
  GROUP_PHOTO_CHIP_LABEL,
  SCOPE_VIDEO_CHIP_LABEL,
  TASK_PHOTO_CHIP_LABEL_FALLBACK,
} from './focusedStripTypes';

export const getVideoTileLabel = (
  video: FocusedMediaStripVideoEntry,
  fileName?: string,
  readStatus?: VideoToolboxClipReadStatus,
): string =>
  [
    fileName,
    video.walkLabel,
    readStatus ? formatVideoToolboxClipReadStatusAriaLabel(readStatus) : undefined,
  ].filter(Boolean).join(' · ');

export const getVideoChipLabel = (
  video: FocusedMediaStripVideoEntry,
  showTaskChipLabels: boolean,
): string | undefined => {
  if (video.scope === 'scope') return SCOPE_VIDEO_CHIP_LABEL;
  if (video.scope === 'group') {
    return getTruncatedChipLabel(video.groupLabel ?? GROUP_PHOTO_CHIP_LABEL);
  }
  if (!showTaskChipLabels) return undefined;
  return video.taskLabel
    ? getTruncatedChipLabel(video.taskLabel)
    : TASK_PHOTO_CHIP_LABEL_FALLBACK;
};
